import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import BottomNav from './components/BottomNav';
import Home from './components/Home';
import About from './components/About';
import Cart from './components/Cart';
import Call from './components/Call';
import Share from './components/Share';
import { CartProvider } from "./context/CartContext"
import { AppProvider } from "./context/AppContext";

const theme = createTheme({
  palette: {
    primary: {
      main: '#033845',//'#B22222', // Correct hex format for primary color
    },
  },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
    <AppProvider>
    <CartProvider>
    <Router>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Box sx={{ flex: 1, overflowY: 'auto', paddingBottom: '56px' }}> {/* Reserve space for BottomNav */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/call" element={<Call />} />
            <Route path="/share" element={<Share />} />
          </Routes>
        </Box>
        <Box sx={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 10 }}>
          <BottomNav />
        </Box>
      </Box>
    </Router>
    </CartProvider>
    </AppProvider>
    </ThemeProvider>
  );
}

export default App;


